module.exports = __webpack_public_path__ + "img/lCallA.06d78345.svg";